// extracted by mini-css-extract-plugin
export var buttonContent = "_42-0";
export var centered = "_42-1";
export var centeredFlex = "_42-2";
export var errorText = "_42-3";
export var icon = "_42-4";
export var iconButtonContent = "_42-5";
export var monospace = "_42-6";
export var padded = "_42-7";